import * as Sentry from '@sentry/react';

if(SENTRY_ENABLED) {
  Sentry.init({
    dsn: `${SENTRY_IO_DSN_WEB_FRONT}`,
    environment: `${SENTRY_ENV}`,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
      //  performance
      // If you're using react router, use the integration for your react router version instead.
      // Learn more at
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.browserTracingIntegration(),
      //  performance
      //  session-replay
      Sentry.replayIntegration(),
      //  session-replay
    ],
    ignoreErrors: [
      'Load failed', // WEBSITE-FRONT-END-5
      'Suspense boundary', // WEBSITE-FRONT-END-4
      'Preflight response is not successful', // WEBSITE-FRONT-END-7
      'about:blank', // WEBSITE-FRONT-END-16
      'Importing a module script failed', // WEBSITE-FRONT-END-D
      'AbortError', // WEBSITE-FRONT-END-9
      'NetworkError when attempting to fetch resource', // WEBSITE-FRONT-END-W
      'doZoom', // WEBSITE-FRONT-END-N
      'loadableErrorRefreshTimeout', // WEBSITE-FRONT-END-Y
    ],
    //  logs
    // Enable logs to be sent to Sentry
    enableLogs: true,
    //  logs
    //  performance
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: SENTRY_PERFORMANCE_SAMPLE_RATE,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ['localhost', 'rockislandauction.com'],
    //  performance
    //  session-replay
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: SENTRY_REPLAY_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: SENTRY_REPLAY_ERROR_SAMPLE_RATE,
    //  session-replay
  });
}

